import {
  PAGE_STARTRUN_INITIALIZE,
  PAGE_STARTRUN_ONCHANGEVALUE,
  PAGE_STARTRUN_PROCESS_RECEIVE,
  PAGE_STARTRUN_USERS_RECEIVE,
  PAGE_STARTRUN_ONSAVE_REQUEST,
  PAGE_STARTRUN_ONSAVE_SUCCESS,
  PAGE_STARTRUN_ONSAVE_ERROR,
  PAGE_STARTRUN_ONFILEUPLOAD_REQUEST,
  PAGE_STARTRUN_ONFILEUPLOAD_RECEIVE
} from '../../actions/page/StartRun';

export default function NewRoutine(
  state = {
    loading: true,
    loadingUsers: true,
    uploadingFiles: false,
    saving: false,
    fields: {}
  },
  action
) {
  switch (action.type) {
    case PAGE_STARTRUN_INITIALIZE:
      return {
        loading: true,
        loadingUsers: true,
        uploadingFiles: false,
        saving: false,
        displayName: '',
        description: '',
        maximumDuration: '7 days',
        isTest: false,
        isScheduled: false,
        isRecurring: false,
        isHighPriority: false,
        hasDeadline: false,
        fields: {},
        runOwner: action.defaultRunOwner
      };

    case PAGE_STARTRUN_ONCHANGEVALUE:
      let prop = {};
      const name = action.name;
      const value = action.value;

      switch (name) {
        case 'displayName':
          prop[name] = value.value;
          break;
        case 'runOwner':
          if (!value.values.length) {
            break;
          }
          // runOwner can only be one user,
          // and may be prefaced by an @.
          const username = value.values[0].split('@');
          prop[name] = username.length > 1 ? username[1] : username[0];
          break;

        case 'priority':
          prop[name] = value === true ? 'High' : 'Medium';
          break;

        case 'fields':
          let fieldObj = {};

          fieldObj[value.fieldID] = value;
          prop[name] = Object.assign({}, state.fields, fieldObj);
          break;

        case 'schedule':
        case 'deadline':
          prop[name] = new Date(value.dateTime).toISOString();
          break;

        default:
          prop[name] = value;
      }

      return Object.assign({}, state, prop);

    case PAGE_STARTRUN_ONSAVE_REQUEST:
      return Object.assign({}, state, { saving: true });

    case PAGE_STARTRUN_ONSAVE_SUCCESS:
      return Object.assign({}, state, {
        saving: false,
        error: null
      });

    case PAGE_STARTRUN_ONSAVE_ERROR:
      return Object.assign({}, state, {
        saving: false,
        error: action.error
      });

    case PAGE_STARTRUN_PROCESS_RECEIVE:
      return Object.assign({}, state, {
        processID: action.process.processID,
        loading: false
      });

    case PAGE_STARTRUN_USERS_RECEIVE:
      return Object.assign({}, state, { loadingUsers: false });

    case PAGE_STARTRUN_ONFILEUPLOAD_REQUEST:
      return Object.assign({}, state, { uploadingFiles: true });

    case PAGE_STARTRUN_ONFILEUPLOAD_RECEIVE:
      return Object.assign({}, state, { uploadingFiles: false });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/StartRun.js